'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoHappy = function IoHappy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m-12 17.3c0.3 0.1 0.5 0.2 0.8 0.2 0.4 0 0.9-0.2 1.1-0.5s0.6-0.7 1.4-0.7 1 0.4 1.3 0.7 0.7 0.5 1.1 0.5c0.3 0 0.5-0.1 0.8-0.2 0.6-0.4 0.7-1.2 0.3-1.8-0.8-1-1.9-1.7-3.6-1.7s-2.5 0.7-3.4 1.7c-0.5 0.6-0.4 1.3 0.2 1.8z m22.8 4.5c0.3-0.6 0.1-1.3-0.6-1.6-0.1-0.1-0.3-0.2-0.5-0.2-0.5 0-0.9 0.2-1.1 0.6-1.4 2.8-4.8 4.4-8.6 4.4-3.9 0-7.3-1.6-8.6-4.3-0.2-0.5-0.6-0.7-1.1-0.7-0.1 0-0.4 0-0.5 0.1-0.7 0.3-1 1-0.7 1.6 1.7 3.5 6.1 5.8 10.9 5.8 4.7 0 8.9-2.1 10.8-5.7z m1.2-4.5c0.6-0.4 0.7-1.2 0.3-1.8-0.8-1-1.9-1.7-3.5-1.7s-2.6 0.7-3.5 1.7c-0.5 0.6-0.4 1.3 0.2 1.8 0.3 0.1 0.5 0.2 0.8 0.2 0.4 0 0.9-0.2 1.1-0.5s0.6-0.7 1.4-0.7 1 0.4 1.3 0.7 0.7 0.5 1.1 0.5c0.3 0 0.5-0.1 0.8-0.2z' })
        )
    );
};

exports.default = IoHappy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/happy.js
// module id = 2522
// module chunks = 168707334958949